import { Component, ElementRef, OnInit, Renderer2, ViewChild } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Observable, EMPTY } from 'rxjs';
import { filter, first, tap } from 'rxjs/operators';

import { AuthService } from 'src/app/auth/services/auth.service';
import { SweetAlertService } from '../../../shared/services/sweet-alert/sweet-alert.service';

import { User } from 'src/app/auth/models/user.model';

import * as _ from 'lodash';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {
  @ViewChild('buttonToggler') buttonToggler: ElementRef;
  @ViewChild('navbarCollapse') navbarCollapse: ElementRef;
  toggled = true;

  signUpButton: boolean = true;
  signInButton: boolean = false;

  user$: Observable<User>;

  newUsersCount: number;

  constructor(
    private router: Router,
    private renderer: Renderer2,
    private authService: AuthService,
    private sweetAlertService: SweetAlertService
  ) {
    // Set the current url to the property lastUrl.
    this.router.events.pipe(
      filter(e => e instanceof NavigationEnd))
      .subscribe((e: NavigationEnd) => {
        // Case event url was different of the '/sign-in' then save the url path.
        switch (e.url) {
          case '/sign-in':
            this.signUpButton = true;
            this.signInButton = false;
            break;
          case '/sign-up':
          case '/reset-password':
            this.signUpButton = false;
            this.signInButton = true;
            break;
          default:
            this.signUpButton = false;
            this.signInButton = false;
            break;
        }
      });
  }

  ngOnInit() {
    this.user$ = this.authService.currentUser$;

    this.authService.getNewUsers().subscribe(
      data => this.newUsersCount = _.filter(data, ['enabled', false]).length
    );
  }

  get userConhecidoComo(): string {
    return this.authService.user && this.authService.user.conhecidoComo;
  }

  get userLastSignInAt(): string {
    return this.authService.user && this.authService.user.lastSignInAt;
  }

  get userIsAdmin(): boolean {
    return this.authService.user && this.authService.user.admin;
  }

  isSignedIn(): boolean {
    return this.authService.isSignedIn();
  }

  async logout() {
    this.navbarToggleCollapse();

    const result = await this.sweetAlertService.confirmation({ message: 'Deseja sair do Sistema?', focusOk: true });

    if (result.value) {
      this.user$ = EMPTY;
      this.authService.signOut();
    }
  }

  navbarToggle() {
    if (this.toggled) {
      this.renderer.addClass(this.buttonToggler.nativeElement, 'collapsed');
      this.renderer.removeClass(this.navbarCollapse.nativeElement, 'show');
    } else {
      this.renderer.removeClass(this.buttonToggler.nativeElement, 'collapsed');
      this.renderer.addClass(this.navbarCollapse.nativeElement, 'show');
    }

    this.toggled = !this.toggled;
  }

  navbarToggleCollapse() {
    if (!this.toggled) {
      this.renderer.addClass(this.buttonToggler.nativeElement, 'collapsed');
      this.renderer.removeClass(this.navbarCollapse.nativeElement, 'show');

      this.toggled = true;
    }
  }

  brandUrl() {
    if (this.isSignedIn()) {
      return '/';
    } else {
      return '/sign-in';
    }
  }
}
